function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M189.895 126.661C188.614 134.116 185.932 141.053 181.303 146.018C173.129 154.797 160.966 155.283 150.32 152.474C139.673 149.664 129.59 144.077 118.816 142.283C104.936 139.965 90.9587 144.067 77.0153 145.736C68.7602 146.724 59.9629 146.724 52.767 141.676C45.7888 136.784 9.75727 109.278 7.60063 99.7876C5.44399 90.2975 0.567225 88.1427 0.584307 78.2864C0.609931 59.7666 71.7873 51.082 78.2231 48.393C89.3266 43.7631 91.0185 16.6309 100.67 8.48014C103.787 5.86435 107.042 3.38459 110.612 1.87267C120.964 -2.52185 129.548 1.71572 139.225 5.39874C149.474 9.31196 159.416 2.33305 169.742 5.30981C180.517 8.41736 186.884 22.574 188.268 36.0191C189.652 49.4642 187.414 63.0873 187.841 76.637C188.195 88.7586 190.638 100.702 190.89 112.813C191.003 117.461 190.669 122.109 189.895 126.661Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.024 33H32.7073C30.7042 33 29.0803 34.6494 29.0803 36.684V117.108C29.0803 119.318 30.8711 121.108 33.0803 121.108H168.651C170.86 121.108 172.651 119.318 172.651 117.108V36.684C172.651 35.7069 172.269 34.7699 171.589 34.079C170.908 33.3881 169.986 33 169.024 33Z",
  fill: "#06172D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.024 33H32.7073C30.7042 33 29.0803 34.6494 29.0803 36.684V117.108C29.0803 119.318 30.8711 121.108 33.0803 121.108H168.651C170.86 121.108 172.651 119.318 172.651 117.108V36.684C172.651 35.7069 172.269 34.7699 171.589 34.079C170.908 33.3881 169.986 33 169.024 33H169.024Z",
  fill: "#C6D7EE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M165.779 35.4334H36.3908C34.1817 35.4334 32.3908 37.2243 32.3908 39.4334V115.232C32.3908 117.441 34.1817 119.232 36.3908 119.232H165.779C167.989 119.232 169.779 117.441 169.779 115.232V39.4334C169.779 37.2243 167.989 35.4334 165.779 35.4334Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M169.779 36.9368H66.0482V117.924H169.779V36.9368Z",
  fill: "#DFEAF8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M61.6964 36.6501H35.8549C34.7503 36.6501 33.8549 37.5455 33.8549 38.6501V116.168C33.8549 117.273 34.7503 118.168 35.8549 118.168H61.6964C62.8009 118.168 63.6964 117.273 63.6964 116.168V38.6501C63.6964 37.5455 62.8009 36.6501 61.6964 36.6501Z",
  fill: "#C6D7EE"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.2269 48.8169C37.7897 48.8178 37.4358 49.1952 37.4358 49.6605C37.4358 50.1258 37.7897 50.5032 38.2269 50.5041H59.2669C59.704 50.5032 60.058 50.1258 60.058 49.6605C60.058 49.1952 59.704 48.8178 59.2669 48.8169H38.2269Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9367 52.467C37.6599 52.4678 37.4358 52.8462 37.4358 53.3126C37.4358 53.779 37.6599 54.1573 37.9367 54.1582H51.2587C51.5355 54.1573 51.7597 53.779 51.7597 53.3126C51.7597 52.8462 51.5355 52.4678 51.2587 52.467H37.9367Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 48.1787,
  cy: 43.9501,
  rx: 2.38732,
  ry: 2.43338,
  fill: "#466089"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.227 60.9839C37.7898 60.9847 37.4359 61.3622 37.4359 61.8275C37.4359 62.2928 37.7898 62.6702 38.227 62.6711H59.267C59.7042 62.6702 60.0581 62.2928 60.0581 61.8275C60.0581 61.3622 59.7042 60.9847 59.267 60.9839H38.227Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9368 64.6339C37.66 64.6348 37.4359 65.0131 37.4359 65.4795C37.4359 65.9459 37.66 66.3243 37.9368 66.3251H51.2589C51.5357 66.3243 51.7598 65.9459 51.7598 65.4795C51.7598 65.0131 51.5357 64.6348 51.2589 64.6339H37.9368Z",
  fill: "#466089"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.227 73.1508C37.7898 73.1517 37.4359 73.5291 37.4359 73.9944C37.4359 74.4597 37.7898 74.8371 38.227 74.838H59.267C59.7042 74.8371 60.0581 74.4597 60.0581 73.9944C60.0581 73.5291 59.7042 73.1517 59.267 73.1508H38.227Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9368 76.8009C37.66 76.8017 37.4359 77.1801 37.4359 77.6465C37.4359 78.1129 37.66 78.4912 37.9368 78.4921H51.2589C51.5357 78.4912 51.7598 78.1129 51.7598 77.6465C51.7598 77.1801 51.5357 76.8017 51.2589 76.8009H37.9368Z",
  fill: "#466089"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.227 85.3177C37.7898 85.3186 37.4359 85.696 37.4359 86.1613C37.4359 86.6266 37.7898 87.004 38.227 87.0049H59.267C59.7042 87.004 60.0581 86.6266 60.0581 86.1613C60.0581 85.696 59.7042 85.3186 59.267 85.3177H38.227Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9368 88.9678C37.66 88.9686 37.4359 89.347 37.4359 89.8134C37.4359 90.2798 37.66 90.6581 37.9368 90.659H51.2589C51.5357 90.6581 51.7598 90.2798 51.7598 89.8134C51.7598 89.347 51.5357 88.9686 51.2589 88.9678H37.9368Z",
  fill: "url(#paint1_linear)"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.4605 43.1233C73.0233 43.1242 72.6694 43.5016 72.6694 43.9669C72.6694 44.4322 73.0233 44.8097 73.4605 44.8105H94.5005C94.9377 44.8097 95.2916 44.4322 95.2916 43.9669C95.2916 43.5016 94.9377 43.1242 94.5005 43.1233H73.4605Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9035 42.561C68.8502 42.5624 68.807 43.1915 68.807 43.967C68.807 44.7425 68.8502 45.3716 68.9035 45.373H71.4694C71.5227 45.3716 71.5658 44.7425 71.5658 43.967C71.5658 43.1915 71.5227 42.5624 71.4694 42.561H68.9035Z",
  fill: "#466089"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.4026 49.3098C72.9974 49.3107 72.6694 49.6881 72.6694 50.1534C72.6694 50.6187 72.9974 50.9961 73.4026 50.997H92.9031C93.3083 50.9961 93.6363 50.6187 93.6363 50.1534C93.6363 49.6881 93.3083 49.3107 92.9031 49.3098H73.4026Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.9555 49.3098C95.2838 49.3107 94.7399 49.6881 94.7399 50.1534C94.7399 50.6187 95.2838 50.9961 95.9555 50.997H128.285C128.957 50.9961 129.501 50.6187 129.501 50.1534C129.501 49.6881 128.957 49.3107 128.285 49.3098H95.9555Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.28 49.3098C130.907 49.3107 130.604 49.6881 130.604 50.1534C130.604 50.6187 130.907 50.9961 131.28 50.997H149.241C149.614 50.9961 149.916 50.6187 149.916 50.1534C149.916 49.6881 149.614 49.3107 149.241 49.3098H131.28Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.579 49.3098C151.27 49.3107 151.02 49.6881 151.02 50.1534C151.02 50.6187 151.27 50.9961 151.579 50.997H166.461C166.77 50.9961 167.021 50.6187 167.021 50.1534C167.021 49.6881 166.77 49.3107 166.461 49.3098H151.579Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9035 48.185C68.8502 48.1865 68.807 48.8155 68.807 49.591C68.807 50.3665 68.8502 50.9956 68.9035 50.9971H71.4694C71.5227 50.9956 71.5658 50.3665 71.5658 49.591C71.5658 48.8155 71.5227 48.1865 71.4694 48.185H68.9035Z",
  fill: "#466089"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.9202 54.9339C78.5151 54.9347 78.187 55.3122 78.187 55.7775C78.187 56.2428 78.5151 56.6202 78.9202 56.6211H98.4208C98.8259 56.6202 99.154 56.2428 99.154 55.7775C99.154 55.3122 98.8259 54.9347 98.4208 54.9339H78.9202Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9202 78.555C78.5151 78.5559 78.187 78.9333 78.187 79.3986C78.187 79.8639 78.5151 80.2414 78.9202 80.2422H98.4208C98.8259 80.2414 99.154 79.8639 99.154 79.3986C99.154 78.9333 98.8259 78.5559 98.4208 78.555H78.9202Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.7852 85.3039C78.4546 85.3048 78.187 85.6822 78.187 86.1475C78.187 86.6128 78.4546 86.9903 78.7852 86.9911H94.6935C95.024 86.9903 95.2916 86.6128 95.2916 86.1475C95.2916 85.6822 95.024 85.3048 94.6935 85.3039H78.7852Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.6107 85.3039C96.939 85.3048 96.3951 85.6822 96.3951 86.1475C96.3951 86.6128 96.939 86.9903 97.6107 86.9911H129.941C130.612 86.9903 131.156 86.6128 131.156 86.1475C131.156 85.6822 130.612 85.3048 129.941 85.3039H97.6107Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.103 90.928C105.922 90.9289 105.775 91.3063 105.775 91.7716C105.775 92.2369 105.922 92.6144 106.103 92.6152H114.827C115.008 92.6144 115.155 92.2369 115.155 91.7716C115.155 91.3063 115.008 90.9289 114.827 90.928H106.103Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.3721 96.5521C90.0416 96.553 89.774 96.9304 89.774 97.3957C89.774 97.861 90.0416 98.2384 90.3721 98.2393H106.28C106.611 98.2384 106.879 97.861 106.879 97.3957C106.879 96.9304 106.611 96.553 106.28 96.5521H90.3721Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.256 96.5521C108.552 96.553 107.982 96.9304 107.982 97.3957C107.982 97.861 108.552 98.2384 109.256 98.2393H143.125C143.829 98.2384 144.398 97.861 144.398 97.3957C144.398 96.9304 143.829 96.553 143.125 96.5521H109.256Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.695 96.5521C145.588 96.553 145.502 96.9304 145.502 97.3957C145.502 97.861 145.588 98.2384 145.695 98.2393H150.827C150.933 98.2384 151.02 97.861 151.02 97.3957C151.02 96.9304 150.933 96.553 150.827 96.5521H145.695Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.567 96.5521C152.322 96.553 152.123 96.9304 152.123 97.3957C152.123 97.861 152.322 98.2384 152.567 98.2393H164.37C164.615 98.2384 164.814 97.861 164.814 97.3957C164.814 96.9304 164.615 96.553 164.37 96.5521H152.567Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.05 102.176C109.517 102.177 109.086 102.554 109.086 103.02C109.086 103.485 109.517 103.863 110.05 103.863H135.709C136.242 103.863 136.674 103.485 136.674 103.02C136.674 102.554 136.242 102.177 135.709 102.176H110.05Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.203 102.176C94.9471 102.177 94.7399 102.554 94.7399 103.02C94.7399 103.485 94.9471 103.863 95.203 103.863H107.519C107.775 103.863 107.982 103.485 107.982 103.02C107.982 102.554 107.775 102.177 107.519 102.176H95.203Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.0894 112.299C85.0765 112.3 84.2564 112.678 84.2564 113.143C84.2564 113.608 85.0765 113.986 86.0894 113.987H134.841C135.854 113.986 136.674 113.608 136.674 113.143C136.674 112.678 135.854 112.3 134.841 112.299H86.0894Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.4493 107.8C90.0761 107.801 89.774 108.179 89.774 108.644C89.774 109.109 90.0761 109.487 90.4493 109.487H108.41C108.783 109.487 109.086 109.109 109.086 108.644C109.086 108.179 108.783 107.801 108.41 107.8H90.4493Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.723 102.176C138.2 102.177 137.777 102.554 137.777 103.02C137.777 103.485 138.2 103.863 138.723 103.863H163.868C164.391 103.863 164.814 103.485 164.814 103.02C164.814 102.554 164.391 102.177 163.868 102.176H138.723Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.4378 90.928C84.0327 90.9289 83.7046 91.3063 83.7046 91.7716C83.7046 92.2369 84.0327 92.6144 84.4378 92.6152H103.938C104.344 92.6144 104.672 92.2369 104.672 91.7716C104.672 91.3063 104.344 90.9289 103.938 90.928H84.4378Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.817 60.558C100.508 60.5588 100.257 60.9363 100.257 61.4016C100.257 61.8669 100.508 62.2443 100.817 62.2452H115.699C116.008 62.2443 116.259 61.8669 116.259 61.4016C116.259 60.9363 116.008 60.5588 115.699 60.558H100.817Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.99 66.1821C137.872 66.1829 137.777 66.5604 137.777 67.0257C137.777 67.491 137.872 67.8684 137.99 67.8693H143.634C143.752 67.8684 143.847 67.491 143.847 67.0257C143.847 66.5604 143.752 66.1829 143.634 66.1821H137.99Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9202 60.558C78.5151 60.5588 78.187 60.9363 78.187 61.4016C78.187 61.8669 78.5151 62.2443 78.9202 62.2452H98.4208C98.8259 62.2443 99.154 61.8669 99.154 61.4016C99.154 60.9363 98.8259 60.5588 98.4208 60.558H78.9202Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.2323 66.1821C79.1021 66.1829 78.187 66.5604 78.187 67.0257C78.187 67.491 79.1021 67.8684 80.2323 67.8693H134.628C135.759 67.8684 136.674 67.491 136.674 67.0257C136.674 66.5604 135.759 66.1829 134.628 66.1821H80.2323Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.4605 71.8061C78.7568 71.807 78.187 72.1845 78.187 72.6497C78.187 73.115 78.7568 73.4925 79.4605 73.4934H113.33C114.034 73.4925 114.603 73.115 114.603 72.6497C114.603 72.1845 114.034 71.807 113.33 71.8061H79.4605Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.722 66.1821C145.295 66.1829 144.95 66.5604 144.95 67.0257C144.95 67.491 145.295 67.8684 145.722 67.8693H166.249C166.675 67.8684 167.021 67.491 167.021 67.0257C167.021 66.5604 166.675 66.1829 166.249 66.1821H145.722Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9035 53.8091C68.8502 53.8105 68.807 54.4396 68.807 55.2151C68.807 55.9906 68.8502 56.6197 68.9035 56.6211H71.4694C71.5227 56.6197 71.5658 55.9906 71.5658 55.2151C71.5658 54.4396 71.5227 53.8105 71.4694 53.8091H68.9035Z",
  fill: "#466089"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.6782 81.4736C63.6787 79.2495 65.456 77.4466 67.6485 77.4461L96.4058 77.4398C98.5997 77.4393 100.378 79.2435 100.378 81.4691L100.369 123.301C100.368 125.526 98.5912 127.329 96.3987 127.329L67.6414 127.335C65.4475 127.336 63.6689 125.532 63.6694 123.306L63.6782 81.4736Z",
  fill: "#A6A8BA"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.6782 81.4736C63.6787 79.2495 65.456 77.4466 67.6485 77.4461L89.9551 77.4412L100.376 89.5899L100.369 123.301C100.368 125.526 98.5912 127.329 96.3987 127.329L67.6414 127.335C65.4475 127.336 63.6689 125.532 63.6694 123.306L63.6782 81.4736Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.1006 96.0388L94.0497 96.0331L94.0451 117.954L68.0959 117.96L68.1006 96.0388Z",
  fill: "#E1E8F3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.0446 106.224L82.677 112.649L73.4095 112.651L78.0446 106.224Z",
  fill: "#C6D0DF"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.3706 101.674L92.3384 112.633L76.3982 112.636L84.3706 101.674Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 2.96311,
  ry: 2.99156,
  transform: "matrix(0.861838 0.507183 -0.492851 0.870114 75.2364 102.614)",
  fill: "#F24390"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.0505 88.8603C69.0507 88.3386 69.4675 87.9157 69.9818 87.9156L87.0247 87.9119C87.5393 87.9118 87.9565 88.3349 87.9564 88.8569V88.8569C87.9563 89.3786 87.5394 89.8015 87.0252 89.8016L69.9822 89.8053C69.4676 89.8055 69.0504 89.3823 69.0505 88.8603V88.8603Z",
  fill: "#E2E8F2"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.4074 91.6308C69.4074 91.3178 69.6576 91.064 69.9661 91.064L83.6765 91.061C83.9852 91.0609 84.2355 91.3148 84.2355 91.628V91.628C84.2354 91.941 83.9853 92.1948 83.6767 92.1948L69.9664 92.1978C69.6576 92.1979 69.4073 91.944 69.4074 91.6308V91.6308Z",
  fill: "#E2E8F2"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.7763 77.3847L100.626 89.8421L91.5294 89.8654C90.4153 89.8682 89.5182 88.9369 89.5435 87.8037L89.7763 77.3847Z",
  fill: "#C9D0DD"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  filter: "url(#filter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.397 82.6744C111.395 80.4465 113.176 78.6399 115.372 78.6421L144.122 78.6707C146.312 78.6728 148.087 80.4734 148.089 82.6952L148.129 124.449C148.131 126.677 146.35 128.483 144.154 128.481L115.404 128.452C113.214 128.45 111.439 126.65 111.437 124.428L111.397 82.6744Z",
  fill: "#A6A8BA"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.397 82.6744C111.395 80.4465 113.176 78.6399 115.372 78.6421L137.664 78.6642L148.097 90.8063L148.129 124.449C148.131 126.677 146.35 128.483 144.154 128.481L115.404 128.452C113.214 128.45 111.439 126.65 111.437 124.428L111.397 82.6744Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.534 100.661C142.534 99.8278 141.87 99.1524 141.051 99.1524L118.8 99.1524C117.981 99.1524 117.317 99.8278 117.317 100.661L117.317 121.026C117.317 121.86 117.981 122.535 118.8 122.535L141.051 122.535C141.87 122.535 142.534 121.86 142.534 121.026L142.534 100.661ZM118.8 99.9064L141.05 99.9064L141.105 99.9085C141.489 99.9373 141.792 100.263 141.792 100.661L141.792 121.026L141.79 121.082C141.761 121.473 141.441 121.78 141.05 121.78L118.8 121.78L118.745 121.778C118.361 121.75 118.058 121.424 118.058 121.026L118.058 100.661L118.06 100.604C118.089 100.214 118.409 99.9064 118.8 99.9064Z",
  fill: "#E2E8F2"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M142.091 104.543L142.074 105.312L117.641 105.39L117.658 104.621L142.091 104.543Z",
  fill: "#E2E8F2"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M142.337 110.847L142.319 111.616L117.886 111.694L117.904 110.925L142.337 110.847Z",
  fill: "#E2E8F2"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M142.281 116.001L142.263 116.769L117.83 116.847L117.847 116.079L142.281 116.001Z",
  fill: "#E2E8F2"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M130.48 99.0068L130.586 121.663L129.854 121.655L129.748 98.9986L130.48 99.0068Z",
  fill: "#E2E8F2"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M123.405 99.706L123.511 122.362L122.779 122.354L122.673 99.6977L123.405 99.706Z",
  fill: "#E2E8F2"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M136.967 99.9068L137.073 122.563L136.341 122.555L136.235 99.8985L136.967 99.9068Z",
  fill: "#E2E8F2"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.777 90.0421C116.777 89.5204 117.194 89.0973 117.708 89.0978L134.75 89.1148C135.263 89.1153 135.678 89.5369 135.679 90.0572V90.0572C135.679 90.579 135.262 91.002 134.748 91.0015L117.706 90.9846C117.193 90.9841 116.778 90.5624 116.777 90.0421V90.0421Z",
  fill: "#E2E8F2"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.137 92.8078C117.137 92.4948 117.387 92.2409 117.696 92.2412L131.405 92.2548C131.712 92.2552 131.962 92.5081 131.962 92.8203V92.8203C131.962 93.1334 131.712 93.3872 131.404 93.3869L117.694 93.3733C117.387 93.373 117.137 93.12 117.137 92.8078V92.8078Z",
  fill: "#E2E8F2"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M137.485 78.6076L148.347 91.0585L139.248 91.0707C138.136 91.0721 137.24 90.1426 137.264 89.0113L137.485 78.6076Z",
  fill: "#C9D0DD"
});

var _ref36 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  filter: "url(#filter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.144 82.6744C159.141 80.4465 160.922 78.6399 163.119 78.6421L191.868 78.6707C194.058 78.6728 195.833 80.4734 195.835 82.6952L195.875 124.449C195.878 126.677 194.097 128.483 191.9 128.481L163.151 128.452C160.961 128.45 159.186 126.65 159.184 124.428L159.144 82.6744Z",
  fill: "#A6A8BA"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.454 83.2707C159.452 81.0428 161.233 79.2362 163.429 79.2384L185.721 79.2605L196.154 91.4026L196.186 125.045C196.188 127.273 194.407 129.079 192.211 129.077L163.461 129.049C161.271 129.047 159.496 127.246 159.494 125.024L159.454 83.2707Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 5.1406,
  ry: 5.18995,
  transform: "matrix(0.861838 0.507183 -0.492851 0.870114 178.034 109.475)",
  fill: "#F24390"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.523 90.0421C164.523 89.5204 164.94 89.0973 165.454 89.0978L182.496 89.1148C183.009 89.1153 183.425 89.5369 183.425 90.0572V90.0572C183.426 90.579 183.009 91.002 182.494 91.0015L165.452 90.9846C164.94 90.9841 164.524 90.5624 164.523 90.0421V90.0421Z",
  fill: "#E2E8F2"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.883 92.8078C164.883 92.4948 165.133 92.2409 165.442 92.2412L179.151 92.2548C179.459 92.2552 179.708 92.5081 179.708 92.8203V92.8203C179.709 93.1334 179.458 93.3872 179.15 93.3869L165.441 93.3733C165.133 93.373 164.884 93.12 164.883 92.8078V92.8078Z",
  fill: "#E2E8F2"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.231 78.6076L196.094 91.0585L186.994 91.0707C185.882 91.0721 184.987 90.1426 185.011 89.0113L185.231 78.6076Z",
  fill: "#C9D0DD"
});

var _ref42 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  filter: "url(#filter3_f)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 137.933,
  y: 15,
  width: 42.186,
  height: 34,
  rx: 2,
  fill: "#718EF7"
}));

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 140.877,
  y: 12,
  width: 42.186,
  height: 34,
  rx: 2,
  fill: "#718EF7"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M148.808 32C148.22 32.0007 147.744 32.3005 147.744 32.67C147.744 33.0395 148.22 33.3393 148.808 33.34H177.102C177.69 33.3393 178.166 33.0395 178.166 32.67C178.166 32.3005 177.69 32.0007 177.102 32H148.808Z",
  fill: "white"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M148.808 37C148.22 37.0007 147.744 37.3005 147.744 37.67C147.744 38.0395 148.22 38.3393 148.808 38.34H177.102C177.69 38.3393 178.166 38.0395 178.166 37.67C178.166 37.3005 177.69 37.0007 177.102 37H148.808Z",
  fill: "white"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 161.97,
  cy: 22.5,
  rx: 4.41482,
  ry: 4.5,
  fill: "white"
});

var _ref47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  x: 36.4866,
  y: 50.257,
  width: 91.074,
  height: 104.261,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.5914,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f",
  x: 84.2144,
  y: 51.4592,
  width: 91.0975,
  height: 104.205,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.5914,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f",
  x: 131.961,
  y: 51.4592,
  width: 91.0975,
  height: 104.205,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.5914,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f",
  x: 127.933,
  y: 5,
  width: 62.186,
  height: 54,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 220.192,
  y1: -16.4098,
  x2: 115.314,
  y2: 193.658,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C5D3F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 37.4359,
  y1: 89.8134,
  x2: 51.7598,
  y2: 89.8134,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 78.187,
  y1: 55.7775,
  x2: 99.154,
  y2: 55.7775,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 78.187,
  y1: 79.3986,
  x2: 99.154,
  y2: 79.3986,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 94.7399,
  y1: 103.02,
  x2: 107.982,
  y2: 103.02,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 84.2564,
  y1: 113.143,
  x2: 136.674,
  y2: 113.143,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})));

function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 156,
    viewBox: "0 0 224 156",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.23ec502a.svg";
export { ForwardRef as ReactComponent };